
import React from 'react';
import { Col, Row, FormGroup, Form, Input, Label } from "reactstrap";
const Contact = () => {
    document.title = "Contact Us";
  return (
    <div className="container p-0  my-3">
    <Row className="m-0 ">
        <Col md={6} sm={12}>
            <h2>ContactUs</h2>
            <Form>
                <FormGroup>
                    <Input
                        id="nameId"
                        name="fullName"
                        placeholder="Full Name"
                        type="text"
                    />
                </FormGroup>
                <FormGroup>
                    <Input
                        id="emailId"
                        name="email"
                        placeholder="Email"
                        type="email"
                    />
                </FormGroup>
                <FormGroup>
                    <Input
                        id="subjectId"
                        name="subject"
                        placeholder="Subject"
                        type="text"
                    />
                </FormGroup>

                <FormGroup>
                    <Input
                        id="messageId"
                        name="message"
                        type="textarea"
                        placeholder="Message"
                    />
                </FormGroup>

                <FormGroup check>
                    <Input type="checkbox" />

                    <Label check>Check me out</Label>
                </FormGroup>
                <FormGroup className="d-flex justify-content-end">
                    <button type="submit" className=" btn-primary rounded p-1">
                        Submit
                    </button>
                </FormGroup>
            </Form>
        </Col>
        <Col md={6} sm={12}>
            <Row>
                <div className=""> <iframe title="This is a unique title" className="col-lg-12 col-md-12 col-sm-12 p-0" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3469.7282953570743!2d72.23897511458223!3d29.582507847201864!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x393c66abe032da15%3A0x8a19a558b256d0fc!2sStreet%20To%20People%20Bazaar%2C%20Khairpur%20Tamewali%2C%20Bahawalpur%2C%20Punjab%2C%20Pakistan!5e0!3m2!1sen!2s!4v1648625609460!5m2!1sen!2s" style={{border: 0}} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" /></div>
            </Row>
            <Row className="mt-3">
                <span>
                    <i className="fa fa-phone"></i> 0092-306-7728788
                </span>
            </Row>
            <Row>
                <span>
                    <i className="fa fa-envelope"></i> majid.qauiub@gmail.com
                </span>
            </Row>
            <Row>
                <span>
                    <i className="fa fa-home"></i> Khairpur Tame Wali, Bahawalpur,
                    Punjab, Pakistan
                </span>
            </Row>
        </Col>
    </Row>
</div>
  );
};
export default Contact;
